/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Certbadge_Err_Name_Required1Inputs */

const vi_certbadge_err_name_required1 = /** @type {(inputs: Certbadge_Err_Name_Required1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vui lòng nhập tên logo`)
};

/**

* @param {Certbadge_Err_Name_Required1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const certbadge_err_name_required1 = /** @type {((inputs?: Certbadge_Err_Name_Required1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Certbadge_Err_Name_Required1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_certbadge_err_name_required1(inputs)
});
export { certbadge_err_name_required1 as "certBadge_err_name_required" }